export const SETPRJLIST = "SETPRJLIST";
export const SETEMPLOYEEADVANCESAVE = "SETEMPLOYEEADVANCESAVE";
export const SETLOCATIONLIST = "SETLOCATIONLIST";
export const SETCOSTCENTERLIST = "SETCOSTCENTERLIST";
export const SETEMPADVLIST = "SETEMPADVLIST";
export const SETEMPADVCUSTLIST = "SETEMPADVCUSTLIST";
export const SETEMPADVNUMBERLIST = "SETEMPADVNUMBERLIST";
export const SETEMPADVFIELDLIST = "SETEMPADVFIELDLIST";
export const SETEMPADVFILTERLIST = "SETEMPADVFILTERLIST";
export const SETEMPADVEDIT = "SETEMPADVEDIT";
export const SETEMPATTACHMENTLIST = "SETEMPATTACHMENTLIST";
export const SETTRAVELADVANCEHEADERFILTERDATA = "SETTRAVELADVANCEHEADERFILTERDATA";
